<template>
  <div class="input-container">
    <legend>{{ legend }}</legend>

    <InputDate :modelValue="modelValue" @update:modelValue="$emit('update:modelValue', $event)" :disabled="disabled" :minDate="minDate" :maxDate="maxDate" />
  </div>
</template>

<script>
import InputDate from './InputDate.vue'

export default {
  name: 'SingleDate',
  components: {
    InputDate,
  },
  props: {
    legend: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
    modelValue: {
      type: String | null,
      required: true,
    },
    minDate: {
      type: String,
      default: null
    },
    maxDate: {
      type: String,
      default: null
    }
  },
}
</script>

<style lang="scss" scoped>
.input-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  legend {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: #606264;
    line-height: 21.82px;
  }
}
</style>
